/* ============================================================
   47X · PDP PACK 3 BAGGY LUNA · bgy47
   Namespace propio. Nada de esto toca otra PDP.

   QUÉ HACE
     · Elegir talla del pack (una variante real del producto).
     · Elegir color y talla del OVER DE REGALO. Eso antes se pedía
       por notas del pedido o por DM; aquí viaja en properties, así
       que el pedido llega surtible.
     · Dos intenciones: agregar (abre la bolsa) y comprar ahora
       (va directo a /checkout).

   REGLAS
     · Una petición por clic: `enVuelo` bloquea el doble disparo.
     · Sin storage: el estado vive en memoria. Nada que se quede
       pegado entre visitas.
     · El aviso dice exactamente qué falta, nunca "error".
   ============================================================ */
(function () {
  'use strict';

  function arranca(raiz) {
    if (!raiz || raiz.dataset.bgy47Init === '1') return;
    raiz.dataset.bgy47Init = '1';

    var btnAdd = raiz.querySelector('[data-bgy47-add]');
    var btnsBuy = raiz.querySelectorAll('[data-bgy47-buy]');
    var aviso = raiz.querySelector('[data-bgy47-aviso]');
    var sticky = raiz.querySelector('[data-bgy47-sticky]');
    var stickyS = raiz.querySelector('[data-bgy47-sticky-s]');
    var cajaReg = raiz.querySelector('[data-bgy47-reg]');

    var variante = '', talla = '', regColor = '', regTalla = '';
    var enVuelo = false;

    function di(msg) { if (aviso) aviso.textContent = msg || ''; }

    /* Un solo listener para todos los botones de opción: menos nodos
       escuchando y funciona igual si el editor re-renderiza. */
    raiz.addEventListener('click', function (ev) {
      var b = ev.target.closest ? ev.target.closest('.bgy47__op') : null;
      if (!b || b.disabled) return;

      var grupo = b.parentNode;
      var hermanos = grupo.querySelectorAll('.bgy47__op');
      for (var i = 0; i < hermanos.length; i++) hermanos[i].setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-pressed', 'true');

      if (b.hasAttribute('data-bgy47-talla')) {
        variante = b.getAttribute('data-bgy47-var') || '';
        talla = (b.textContent || '').trim();
      } else if (b.hasAttribute('data-bgy47-rc')) {
        regColor = b.getAttribute('data-bgy47-rc') || '';
      } else if (b.hasAttribute('data-bgy47-rt')) {
        regTalla = b.getAttribute('data-bgy47-rt') || '';
      }
      di('');
      pinta();
    });

    function pinta() {
      if (!stickyS) return;
      var partes = [];
      if (talla) partes.push('Talla ' + talla);
      if (regColor || regTalla) partes.push('Regalo ' + (regColor || '') + (regTalla ? ' ' + regTalla : ''));
      stickyS.textContent = partes.length ? partes.join(' · ') : (stickyS.dataset.bgy47Base || stickyS.textContent);
    }
    if (stickyS) stickyS.dataset.bgy47Base = stickyS.textContent;

    /* Qué falta para poder comprar. Devuelve '' si está completo. */
    function queFalta() {
      if (!variante) return 'Elige tu talla para continuar';
      if (cajaReg) {
        if (!regColor) return 'Elige el color de tu over de regalo';
        if (!regTalla) return 'Elige la talla de tu over de regalo';
      }
      return '';
    }

    function props() {
      var o = {};
      if (regColor) o['Over de regalo · color'] = regColor;
      if (regTalla) o['Over de regalo · talla'] = regTalla;
      return o;
    }

    function manda(aCheckout, btn) {
      if (enVuelo) return;
      var falta = queFalta();
      if (falta) { di(falta); return; }

      enVuelo = true;
      var prev = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'UN SEGUNDO…';

      /* Para COMPRAR AHORA se usa el form nativo con return_to: el
         navegador navega solo y no hay un fetch que pueda quedarse a
         medias antes del redirect. */
      if (aCheckout) {
        var f = document.createElement('form');
        f.method = 'post';
        f.action = '/cart/add';
        f.style.display = 'none';
        function campo(n, v) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i);
        }
        campo('id', variante);
        campo('quantity', '1');
        var pr = props();
        for (var k in pr) if (pr.hasOwnProperty(k)) campo('properties[' + k + ']', pr[k]);
        campo('return_to', '/checkout');
        document.body.appendChild(f);
        f.submit();
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1, properties: props() }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          enVuelo = false;
          if (btn) btn.textContent = prev;
          di('');
          /* La bolsa del tema escucha estos dos: uno repinta, el otro abre. */
          try { window.dispatchEvent(new CustomEvent('cart47:refresh')); } catch (e) {}
          try { window.dispatchEvent(new CustomEvent('cart47:open')); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('cart47:added')); } catch (e) {}
        })
        .catch(function () {
          enVuelo = false;
          if (btn) btn.textContent = prev;
          di('No se pudo agregar · inténtalo de nuevo');
        });
    }

    if (btnAdd) btnAdd.addEventListener('click', function () { manda(false, btnAdd); });
    for (var j = 0; j < btnsBuy.length; j++) {
      (function (b) { b.addEventListener('click', function () { manda(true, b); }); })(btnsBuy[j]);
    }

    /* El sticky entra cuando el botón principal ya salió de pantalla.
       Con IntersectionObserver, sin escuchar scroll. */
    if (sticky && btnAdd && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) sticky.classList.toggle('is-on', !es[i].isIntersecting);
      }, { threshold: 0 });
      io.observe(btnAdd);
    }
  }

  function todo(ambito) {
    var ns = (ambito || document).querySelectorAll('[data-bgy47]');
    for (var i = 0; i < ns.length; i++) { try { arranca(ns[i]); } catch (e) {} }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { todo(); }, { once: true });
  } else { todo(); }

  if (!window.__BGY47_HOOK) {
    window.__BGY47_HOOK = 1;
    document.addEventListener('shopify:section:load', function (e) { todo(e.target); });
  }
})();
